// extracted by mini-css-extract-plugin
export default {"tabsCard":"_2XbSHYoXbEZ7Ghq4_R3B2x","placeholderPanel":"_1Z2Z4Q_1I8Sd_Lm2ftnjs3"};